import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type {
  CourseProgressSpellingData,
  CourseProgressLessonData,
} from 'teacher-ui-client/components/giraffe/charts/course-progress/history'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface CourseProgressLessonHistoryResponse {
  course_progress_history: {
    student_id: number
    max_lesson: number
    lessons_completed: number
    lessons: { assignment: boolean; lesson: number }[]
  }[]
}

export async function courseProgressLessonHistory(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex | LegacyProductMs,
  precinct: LegacyPrecinctReading | LegacyPrecinctLessons | LegacyPrecinctMyLessons,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<CourseProgressLessonData[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('course_progress_history', product, statsScope)
  const query = this.buildQuery(statsScope, period, { precinct })

  const data = await this.fetchData<CourseProgressLessonHistoryResponse>(url, query)
  if (!data) return null

  if (data.course_progress_history.length === 0) {
    return null
  }

  return data.course_progress_history
}

export interface CourseProgressSpellingHistoryResponse {
  course_progress_history: {
    student_id: number
    average_score: number
    lessons_completed: number
    lessons: { assignment: boolean; lesson: number }[]
  }[]
}

export async function courseProgressSpellingHistory(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<CourseProgressSpellingData[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('course_progress_history', product, statsScope)
  const query = this.buildQuery(statsScope, period, { precinct: 'spelling' })

  const data = await this.fetchData<CourseProgressSpellingHistoryResponse>(url, query)
  if (!data) return null

  if (data.course_progress_history.length === 0) {
    return null
  }

  return data.course_progress_history
}
